//page-top スクロールイン
function PageTopAnime() {
    var scroll = $(window).scrollTop();
    var divHeight = window.outerHeight - 100;
    if (scroll >= divHeight) {
      $('#page-top').removeClass('DownMove');
      $('#page-top').addClass('UpMove');
    } else {
      if ($('#page-top').hasClass('UpMove')) {
        $('#page-top').removeClass('UpMove');
        $('#page-top').addClass('DownMove');
      }
    }
  }
  $(window).scroll(function () {
    PageTopAnime();
  });
  
  $('#page-top a').click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1500);
    return false;
  });
  
//携帯メニューonoff
  $(function () {
    $('.hamburger').click(function () {
      $(this).toggleClass('active');
      $("body").toggleClass("active");
      if ($(this).hasClass('active')) {
        $('.globalMenuSp').addClass('active');
      } else {
        $('.globalMenuSp').removeClass('active');
      }
    });
    $('.close_menu').click(function () {
      $('.hamburger').removeClass('active');
      $('.globalMenuSp').removeClass('active');
      $("body").toggleClass("active");
    });
    $('.link_btn').click(function () {
      $('.hamburger').removeClass('active');
      $('.globalMenuSp').removeClass('active');
      $("body").toggleClass("active");
    });
  });
